<template>
  <v-sheet>
    <v-data-table
      :headers="headers"
      :items="data"
      dense
      sort-by="onTheDay, order"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar dense elevation="0">
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click="(dialog=true)">
            <v-icon>mdi-plus</v-icon>
            追加
          </v-btn>
          <v-btn class="ms-2" color="error" dark @click="deduplicate">
            <v-icon>mdi-broom</v-icon>
            重複削除
          </v-btn>
        </v-toolbar>
        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.id"
                      :readonly="(0 <= editedIndex)"
                      label="ID"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.onTheDay"
                      label="当日(1:有 2:美容)"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.name"
                      label="名称"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.abbr"
                      label="略称"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.order"
                      label="並び順"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-select :items="years" v-model="selectedYear" item-text="text" item-value="value" label="年度"></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <div class="mb-2">時間帯と枠数（開始時刻のみ、重複不可／初期値20）</div>
                    <v-simple-table dense>
                      <thead>
                        <tr>
                          <th class="text-left">時間</th>
                          <th class="text-right">枠数</th>
                          <th class="text-right">操作</th>
                        </tr>
                      </thead>
                       <tbody>
                        <tr v-for="(row, idx) in yearSlotsLocal" :key="idx">
                          <td style="width: 170px">
                            <v-select :items="timeOptions" item-text="text" item-value="value"
                                      :value="row.time" @change="(v) => updateTimeRow(idx, 'time', v)"
                                      dense hide-details></v-select>
                          </td>
                          <td style="width: 120px">
                            <v-text-field type="number" min="1" :value="row.capacity"
                                          @input="(val)=>updateTimeRow(idx, 'capacity', parseInt(val || 20))"
                                          dense hide-details class="text-right"></v-text-field>
                          </td>
                          <td class="text-right">
                            <v-btn icon small @click="removeTimeRow(idx)"><v-icon small>mdi-delete</v-icon></v-btn>
                          </td>
                        </tr>
                        <tr v-if="yearSlots.length === 0">
                          <td colspan="3" class="text-center grey--text">時間帯がありません。「追加」から登録してください</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                    <div class="mt-2" style="text-align:right">
                      <v-btn small color="primary" text @click="addTimeRow"><v-icon small class="mr-1">mdi-plus</v-icon>追加</v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">
                キャンセル
              </v-btn>
              <v-btn color="blue darken-1" text @click="save"> 保存 </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5"
              >本当にこの項目を削除しますか？</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >キャンセル</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >削除</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <!--<v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>-->
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize"> 更新 </v-btn>
      </template>
      <template v-slot:bottom> </template>
    </v-data-table>
  </v-sheet>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
export default {
  data: () => ({
    dialog: false,
    dialogDelete: false,
    headers: [
    {
        text: "ID",
        align: "end",
        value: "id",
      },
      { text: "当日(1:有, 2:美容)", value: "onTheDay" },
      { text: "名称", value: "name" },
      { text: "略名", value: "abbr" },
      {
        text: "並び順",
        align: "end",
        value: "order",
      },
      { text: "操作", value: "actions", sortable: false },
    ],
    editedIndex: -1,
    editedItem: {
      id: 0,
    },
    defaultItem: {
      order:1,
      text:"",
      abbr:"",
      timeSlots: {},
    },
    selectedYear: null,
    yearSlotsLocal: [],
  }),
  

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    selectedYear() {
      // 年度切替時に該当年度の行をローカル編集配列へ反映
      this.yearSlotsLocal = this.yearSlots.slice();
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions("preparationPlace", ["load", "update", "delete", "deduplicate"]),

    initialize() {
      this.load(false);
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      // 年度の初期値は翌年
      this.selectedYear = moment().year() + 1;
    },

    editItem(item) {
      this.editedIndex = this.data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      if(!this.editedItem.timeSlots) this.editedItem.timeSlots = {};
      this.selectedYear = this.selectedYear ?? (moment().year() + 1);
      // ローカル編集配列に反映
      this.yearSlotsLocal = this.yearSlots.slice();
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.delete(this.editedItem);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      // ソート・重複排除してから保存
      const rows = this.yearSlotsLocal;
      const uniqKeys = Array.from(new Set(rows.map(r => r.time))).sort((a,b)=>a-b);
      const normalized = uniqKeys.map(k => ({ time:k, capacity: Math.max(1, (rows.find(r=>r.time===k)?.capacity || 20)) }));
      const map = {};
      normalized.forEach(r => map[r.time] = r.capacity);
      if(!this.editedItem.timeSlots) this.editedItem.timeSlots = {};
      this.$set(this.editedItem.timeSlots, this.selectedYear, map);
      this.update(this.editedItem);
      this.close();
    },
    addTimeRow() {
      const rows = this.yearSlotsLocal.slice();
      // 末尾の時間＋30分（存在しなければ最初の時間）
      const times = this.timeOptions.map(o => o.value);
      let newTime = this.timeOptions[0].value;
      if (rows.length > 0) {
        const lastTime = rows.map(r => r.time).sort((a,b)=>a-b).pop();
        const idx = times.indexOf(lastTime);
        if (idx >= 0 && idx < times.length - 1) {
          newTime = times[idx + 1];
        } else {
          newTime = lastTime; // 末尾が最大なら据え置き
        }
      }
      rows.push({ time: newTime, capacity: 20 });
      this.yearSlotsLocal = rows;
    },
    removeTimeRow(index) {
      const rows = this.yearSlotsLocal.slice();
      rows.splice(index, 1);
      this.yearSlotsLocal = rows;
    },
    updateTimeRow(index, field, value) {
      const rows = this.yearSlotsLocal.slice();
      const row = Object.assign({}, rows[index]);
      row[field] = field === 'capacity' ? Math.max(1, parseInt(value || 20)) : value;
      rows.splice(index, 1, row);
      this.yearSlotsLocal = rows;
    },
  },
  computed: {
    ...mapState("preparationPlace", ["data"]),
    formTitle() {
      return this.editedIndex === -1 ? "新規登録" : "項目の編集";
    },
    years() {
      const current = moment().year();
      // 今年〜+8年程度を表示
      const list = [];
      for (let y = current; y <= current + 8; y++) {
        list.push({ text: `${y}年度`, value: y });
      }
      return list;
    },
    timeOptions() {
      // 3:00〜10:30 を30分刻み
      const options = [];
      let date = new Date(2021, 0, 1, 3, 0, 0);
      while (date.getHours() < 11) {
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const value = hours * 100 + minutes;
        const text = date.toLocaleTimeString("ja-JP", {
          hour: "2-digit",
          minute: "2-digit",
        });
        options.push({ text, value });
        date.setMinutes(date.getMinutes() + 30);
      }
      return options;
    },
    yearSlots: {
      // [{time:HHmm, capacity:number}] 形式
      get() {
        if (!this.editedItem.timeSlots) return [];
        const slotMap = this.editedItem.timeSlots[this.selectedYear] || {};
        // 保存形式: { [HHmm]: capacity }
        const rows = Object.keys(slotMap).map((k) => ({ time: parseInt(k), capacity: slotMap[k] }));
        return rows.sort((a, b) => a.time - b.time);
      },
      set(rows) {
        const map = {};
        rows.forEach((r) => {
          if (r && r.time != null) {
            map[r.time] = Math.max(1, parseInt(r.capacity || 20));
          }
        });
        if (!this.editedItem.timeSlots) this.editedItem.timeSlots = {};
        this.$set(this.editedItem.timeSlots, this.selectedYear, map);
      },
    },
  },
};
</script>